import { Resolutions } from '@innovyze/stylovyze';
import { TFunction } from 'i18next';

/**
 * Resolution labels by resolution key
 * @readonly
 */
const labels: { [key: string]: string } = {
	[Resolutions['RAW']]: 'Raw',
	[Resolutions['15-MINUTE']]: '15 Minutes',
	[Resolutions['30-MINUTE']]: '30 Minutes',
	[Resolutions['HOURLY']]: 'Hourly',
	[Resolutions['DAILY']]: 'Daily',
	[Resolutions['WEEKLY']]: 'Weekly',
	[Resolutions['MONTHLY']]: 'Monthly',
	AUTO: 'Auto',
};

/**
 * Get localized resolution label
 * @author Luis Alcaras <luis.alcaras@autodesk.com>
 * @param t i18n translate function
 * @param resolution resolution
 * @returns string
 */
export const getLocalizedResolutionLabel = (
	t: TFunction,
	resolution: Resolutions,
) => t(labels[resolution]);
